import React from 'react';
import _ from 'lodash';
import { Errors } from '../../constants/errors';
import { newsletterSubscribe } from '../../services/Api/User/UserService';
import { withTranslation } from 'react-i18next';
import './index.scss';
class SignupNews extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      Email: '',
      isSuccess: false
    };
  }

  handleSubmitClick(event) {
    event.preventDefault();
    let error = '',
      newState = {};
    if (_.isEmpty(this.state.Email) || _.isEmpty(this.state.Email.trim())) {
      error = Errors['Required'];
    } else if (!_.validateEmail(this.state.Email)) {
      error = Errors['Email'];
    } else {
      const subscribeData = {
        PartnerUsername: 'Singlecare',
        PartnerPassword: '564s8734cx@G',
        EmailContactTypeId: 63,
        SendEmail: true,
        ContactValues: { ContactTypeId: 0, Subsource: 'Blog newsletter' },
        ProspectValues: {
          Email: this.state.Email,
          FirstName: '',
          LastName: ''
        }
      };
      newsletterSubscribe(subscribeData).then(res => {
        if (res.status === 200 && res.data.Success) {
          this.setState({
            EmailError: '',
            Email: '',
            isSuccess: true
          });
        }
        setTimeout(() => {
          this.setState({ isSuccess: false });
        }, 2000);
      });
    }
    newState[`EmailError`] = error;
    this.setState(Object.assign({}, this.state, newState));
  }

  onInputChange(event = { target: { name: '', value: '' } }) {
    const { name, value } = event.target;
    let newState = {};
    newState[`${name}Error`] = '';
    newState[name] = value;
    this.setState(Object.assign({}, this.state, newState));
  }

  render() {
    const { Email, EmailError, isSuccess } = this.state;
    const { t, i18n } = this.props;
    let lang = i18n.language;
    return (
      <div className="signupNewsLetterWrapper">
        <div className="newsLetterWrapper">
          <div className="newsLetterLeft">
            <h2 className="textCenter">
              Subscribe to our&nbsp;
              <span>savings newsletter</span>
            </h2>
            <p>Health education, drug info, wellness & more</p>
          </div>
          <div className="newsLetterRight">
            <div className="subscribeBox">
              <form autoComplete="on">
                <div className="subscribeForm">
                  <div className="inputText">
                    <label id="subscribe-news-letter-email">Email</label>
                    <div className="news-letter-wrapper">
                      <input
                        type="text"
                        className={`whiteFocus ${
                          EmailError && 'news-letter-email-error'
                        }`}
                        placeholder={t('EmailPlaceHolder')}
                        name="Email"
                        autoComplete="email"
                        value={Email}
                        onChange={this.onInputChange.bind(this)}
                        required
                        aria-labelledby="subscribe-news-letter-email"
                        aria-required="true"
                        aria-invalid={EmailError ? 'true' : 'false'}
                        aria-describedby="invalidEmailError"
                      />
                      {EmailError && (
                        <img
                          className="news-letter-email-errorImg"
                          src="/content/images/icons/error.svg"
                          alt=""
                          aria-labelledby="subscribe-news-letter-email"
                        />
                      )}
                    </div>
                  </div>
                  <div className="inputButton">
                    <button
                      onClick={this.handleSubmitClick.bind(this)}
                      className={`whiteFocus ${
                        isSuccess ? 'activeSent' : 'inActiveSent'
                      }`}
                      aria-live="polite"
                      aria-describedby="terms_conds"
                    >
                      {isSuccess ? 'Subscribed!' : 'Subscribe'}
                    </button>
                  </div>
                </div>

                <span
                  id="invalidEmailError"
                  className={`${
                    !EmailError ? 'visibilityHidden' : 'label-error'
                  }`}
                  role="alert"
                >
                  {EmailError}
                </span>

                {/*{isSuccess && (
                  <span className="label-error" role="status">
                    Thank You.
                  </span>
                )}*/}
              </form>
              <div id="terms_conds" className="TermsConditions">
                {t("By clicking 'Subscribe', I agree to SingleCare's")}&nbsp;
                <a
                  target="_blank"
                  href={_.withLocale(lang, '/terms-and-conditions')}
                  rel="noopener noreferrer"
                >
                  Terms & Conditions.
                </a>
                {i18n.language === 'es' && <span> de SingleCare.</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(SignupNews);
